module.exports = __webpack_public_path__ + "static/boyle-hex-b52cdbad187119e5be77ac17ea485f38.png";